import React from 'react';
import { Table, Button } from 'antd';
import dayjs from 'dayjs';
import type { FM030 } from '../../../services/pwm211Api';
import type { ColumnsType } from 'antd/es/table';

interface ResultGridProps {
  data: FM030[];
  total: number;
  loading: boolean;
  page: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
  onReply: (row: FM030) => void;
}

const ResultGrid: React.FC<ResultGridProps> = React.memo(({
  data, total, loading, page, pageSize, onPageChange, onReply,
}) => {
  const columns: ColumnsType<FM030> = [
    {
      title: '項次',
      dataIndex: 'fm030_04',
      width: 60,
      align: 'center',
    },
    {
      title: '查閱',
      key: 'reply',
      width: 70,
      align: 'center',
      render: (_: unknown, row: FM030) => (
        <Button size="small" onClick={() => onReply(row)}>
          查閱
        </Button>
      ),
    },
    {
      title: '庫位',
      dataIndex: 'fm030_01',
      width: 80,
    },
    {
      title: '批號',
      dataIndex: 'fm030_03',
      width: 130,
    },
    {
      title: '產品代號',
      dataIndex: 'fm030_02',
      width: 130,
    },
    {
      title: '庫存量',
      dataIndex: 'fm030_16',
      width: 100,
      align: 'right',
      render: (v: number) => v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: '單價',
      dataIndex: 'fm030_18',
      width: 100,
      align: 'right',
      render: (v: number) => v.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }),
    },
    {
      title: '金額',
      dataIndex: 'fm030_17',
      width: 110,
      align: 'right',
      render: (v: number) => v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: '色號',
      dataIndex: 'fm030_51',
      width: 70,
    },
    {
      title: '入庫日期',
      dataIndex: 'fm030_13',
      width: 110,
      align: 'center',
      render: (v: string | null) => v ? dayjs(v).format('YYYY/MM/DD') : '—',
    },
  ];

  return (
    <Table<FM030>
      dataSource={data}
      columns={columns}
      rowKey={r => `${r.fm030_01}-${r.fm030_02}-${r.fm030_03}`}
      loading={loading}
      size="small"
      scroll={{ x: 900 }}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: true,
        showTotal: (t) => `共 ${t} 筆`,
        onChange: onPageChange,
      }}
    />
  );
});

ResultGrid.displayName = 'ResultGrid';

export default ResultGrid;
